function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".warning-class{fill:#d91b5b;}.warning-class,.cls-2,.cls-3{stroke-width:0px;}.cls-2{fill:none;}.cls-3{fill:#fff;}.cls-4{clip-path:url(#clippath);}"), /*#__PURE__*/React.createElement("clipPath", {
  id: "clippath"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  y: 0.03,
  width: 584.78,
  height: 516.7
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18351"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_32433",
  className: "warning-class",
  d: "M258.93,19.35L5.24,458.74c-10.67,18.48-4.34,42.12,14.14,52.79,5.88,3.39,12.55,5.18,19.33,5.18h507.37c21.34,0,38.65-17.29,38.66-38.63,0-6.79-1.78-13.46-5.18-19.33L325.87,19.35c-10.66-18.49-34.29-24.84-52.78-14.18-5.89,3.4-10.78,8.29-14.18,14.18"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_32434",
  className: "cls-3",
  d: "M293.02,387.17c16.11-1.11,30.07,11.05,31.18,27.16.03.39.05.79.06,1.18v4.12c-1.74,17.25-17.13,29.81-34.38,28.07-14.84-1.5-26.58-13.23-28.07-28.07v-4.12c.57-16.25,14.21-28.95,30.45-28.38.26.01.52.02.78.04"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_32435",
  className: "cls-3",
  d: "M307.64,165.84c9.15,5.5,14.36,15.73,13.45,26.36l-12.89,150.19c-.15,8.27-6.93,14.87-15.2,14.79-8.07.09-14.7-6.37-14.79-14.45,0-.11,0-.23,0-.34l-12.89-150.19c-1.33-15.39,10.08-28.94,25.47-30.27,5.88-.51,11.77.86,16.83,3.91h.02Z"
})));

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 584.78 516.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.796609d8.svg";
export { ForwardRef as ReactComponent };